import { Button, Rate } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../../app/store";
import VerifyIcon from "../../../../assets/icons/VerifyIcon";
import PROFILE_IMG from "../../../../assets/images/avatar.svg";
import CustomEmpty from "../../../../components/ui/CustomEmpty";
import Loader from "../../../../components/ui/Loader";
import { useGetJobAppliedListQuery } from "../../../../features/organization/job/jobApi";
import useError from "../../../../hooks/useError";
import { formatDate, formatShortRelativeTime } from "../../../../lib/time";
import { underscoreToCapitalizeString } from "../../../../utils/utils";
import LocationIcon from "../../dashboard/_icons/LocationIcon";

const ProjectUserList = ({ id }: { id: number }) => {
  const { user } = useAppSelector((state) => state.auth);
  const { isLoading, isFetching, isError, error, data } =
    useGetJobAppliedListQuery(
      {
        params: {
          skip: 0,
          limit: 0,
          job_id: id,
          business_id: user?.business_id,
          is_hired: 1,
        },
      },
      {
        skip: !id,
      }
    );
  useError(isError, error, "Project applied user get fail");

  if (isLoading || isFetching) {
    return <Loader className="!h-16" />;
  }

  if (!data?.data?.jobApplies?.length) {
    return (
      <CustomEmpty rootClassName="py-10" styles={{ image: { height: 100 } }} />
    );
  }

  console.log("data:", data);
  return (
    <section>
      {data?.data?.jobApplies?.map((job) => {
        const applicant = job.applicant;
        return (
          <div
            className="grid grid-cols-12 gap-6 p-4 border-b border-light last:border-b-0"
            key={job.id}
          >
            <div className="col-span-3">
              <div className="flex gap-2.5">
                <img
                  className="w-11 h-11 rounded-full"
                  src={applicant?.profile?.pro_pic || PROFILE_IMG}
                  alt={applicant?.name}
                />

                <div>
                  <div className="flex items-center gap-x-4 flex-wrap">
                    <h4 className="text-base font-medium text-header">
                      {applicant?.name}
                    </h4>
                    {!!applicant?.is_verified && (
                      <span className="text-xs font-medium flex items-center gap-1.5 text-link">
                        <VerifyIcon />
                        Verified
                      </span>
                    )}
                  </div>

                  <div className="flex items-center gap-1 text-sm text-body-text font-medium my-1">
                    <LocationIcon />
                    {applicant?.profile?.district || "N/A"}
                  </div>

                  {/* Todo: Need to show rating */}
                  <div className="flex items-center flex-wrap gap-x-3">
                    <Rate
                      disabled
                      allowHalf
                      value={0}
                      style={{ color: "#FFC700" }}
                    />

                    {/* <div>
                      <span className="text-header text-base font-medium inline-block mr-1">
                        4.8
                      </span>
                      <span className="text-header text-sm font-normal inline-block">
                        (251)
                      </span>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-2 flex justify-center">
              <div>
                <p className="text-body-text text-base font-normal mb-2">
                  {job?.created_at ? formatDate(job?.created_at) : "-"}
                </p>
                <h6 className="text-lg font-medium text-header">
                  {job?.created_at
                    ? formatShortRelativeTime(job?.created_at)
                    : "-"}
                </h6>
              </div>
            </div>

            <div className="col-span-2 flex justify-center">
              {job?.job?.job_category === "call_center" ? null : (
                <div>
                  <p className="text-body-text text-base font-normal mb-2">
                    Price
                  </p>
                  <h6 className="text-lg font-medium text-header">
                    ৳ {job?.price}/
                    {underscoreToCapitalizeString(
                      job?.job?.contract_type ?? ""
                    )}
                  </h6>
                </div>
              )}
            </div>

            <div className="col-span-2 flex justify-center">
              <div>
                <p className="text-body-text text-base font-normal mb-2">
                  Hire Status
                </p>
                <div>
                  {job?.is_closed ? (
                    <span className="!px-2.5 status-info">Closed</span>
                  ) : job?.is_submitted_task ? (
                    <span className="!px-2.5 status-warning">
                      Request to Close
                    </span>
                  ) : (
                    <span className="!px-2.5 status-success">Hired</span>
                  )}
                </div>
              </div>
            </div>

            <div className="col-span-2 flex justify-center">
              <div className="text-slate-500 text-sm font-normal line-clamp-5">
                {applicant?.profile?.description || ""}
              </div>
            </div>

            <div className="my-auto ml-auto">
              <Link to={`/organization/my-projects/details/${job?.id}`}>
                <Button className="!text-primary font-medium" type="text">
                  View
                </Button>
              </Link>
            </div>
          </div>
        );
      })}
    </section>
  );
};

export default ProjectUserList;
